import React from "react";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { isEmptyCellValue, EmptyLabel } from "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import { getTransactionDuration } from "../utils.js";
function TransactionDuration(props) {
  const formattedValue = getTransactionDuration(props);
  return /* @__PURE__ */ React.createElement(LocalizedText, { label: formattedValue });
}
const renderTransactionDuration = (params) => {
  const transactionDurationProps = params.value;
  const isEmpty = isEmptyCellValue(transactionDurationProps?.started_at?.seconds);
  return isEmpty ? /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" }) : /* @__PURE__ */ React.createElement(TransactionDuration, { history: transactionDurationProps?.history, started_at: transactionDurationProps?.started_at });
};
export {
  renderTransactionDuration
};
//# sourceMappingURL=DurationCell.js.map
